import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import PesquisaCongresso from '../../components/suporte/PesquisaCongresso';
import Header from '../../components/layouts/header';
import Body from '../../components/layouts/body';

class Congressos extends React.Component {
    
    render() {
        return (
            <>
            <DashboardMenu />
            <Header titulo="Suporte" subtitulo="Suporte Congresso" descricao="" />
            <Body>
                <PesquisaCongresso />
            </Body>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        
    }
}

export default connect(mapStateToProps)(withRouter(Congressos));